import React from "react";
import { Select, SelectOption } from "@showitinc/showit-wc";

import AppConstants from "../constants/AppConstants";
import { initFormatter } from "../utils/PropertyFormatters";
import { useBlockStates } from "../hooks/useBlockStates";

const { LINK_STATE_NEXT, LINK_STATE_PREVIOUS, SELECT_EMPTY_OPTION_TEXT } = AppConstants;

const BlockStateSelectInput = ({
  propName,
  value,
  onChange,
  label = "Canvas View",
  enableNextPrevious = true,
  disabled,
  blockSlug,
  pageSlug = null,
}) => {
  const { maxViews, hasNoViews, states } = useBlockStates(blockSlug, pageSlug);

  const { onChange: _onChange } = initFormatter((propInfo) => {
    const newValue = propInfo.value;
    const numValue = newValue !== "" && !isNaN(newValue) ? Number(newValue) : newValue;
    onChange({...propInfo, value: numValue});
  });

  const selectValue = hasNoViews ? "no-views" : (value === null ? "" : String(value));

  return (
    <Select
      data-testid="link-state-select"
      value={selectValue}
      label={label}
      disabled={disabled || hasNoViews}
      reserveContext
      onSISelect={_onChange(propName, value, true, true, undefined, undefined)}
      shift="left"
      filter
    >
      {hasNoViews ? (
        <SelectOption value="no-views" disabled>
          No Views Available
        </SelectOption>
      ) : (
        <>
          <SelectOption value="">{SELECT_EMPTY_OPTION_TEXT}</SelectOption>
          {enableNextPrevious && (
            <>
              <SelectOption value={LINK_STATE_NEXT}>Next</SelectOption>
              <SelectOption value={LINK_STATE_PREVIOUS}>Previous</SelectOption>
            </>
          )}
          {states && states.slice(0, maxViews).map((state, i) => {
              const displayName = state.get("name");
              return (
                <SelectOption key={i} value={String(i)}>
                  {displayName}
                </SelectOption>
              );
            })
          }
        </>
      )}
    </Select>
  );
};

export default BlockStateSelectInput;